import { render, staticRenderFns } from "./RiskCodeView.vue?vue&type=template&id=a9c64b7e&scoped=true&"
import script from "./RiskCodeView.vue?vue&type=script&lang=js&"
export * from "./RiskCodeView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9c64b7e",
  null
  
)

export default component.exports